import React from "react";
import { Provider } from "react-redux";
import { baseContainer } from "../index";
import { SnackbarProvider } from "notistack";
import { useAuth0 } from "@auth0/auth0-react";

const SFProvider = ({
  history,
  store,
  auth0Config,
  persistor,
  themeProvider,
  children,
}) => {

  const {
    user,
    isAuthenticated,
    getAccessTokenSilently,
    isLoading,
    loginWithPopup,
    loginWithRedirect,
    handleRedirectCallback,
    error,
    getIdTokenClaims,
    logout,
  } = useAuth0();

  const auth0Instance = {
    user,
    isAuthenticated,
    getAccessTokenSilently,
    isLoading,
    loginWithPopup,
    loginWithRedirect,
    handleRedirectCallback,
    error,
    getIdTokenClaims,
    logout: () => {
       
      logout({ logoutParams: { returnTo: window.location.origin } });
    },
  };

  baseContainer.setStore(store);
  baseContainer.setHistory(history);
  baseContainer.setPersistor(persistor);
  baseContainer.authenticationService.setAppSetting(auth0Config, auth0Instance);
  if (themeProvider) {
    let ThemeProvider = themeProvider;
    return (
      <Provider store={store}>
        <ThemeProvider>
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            {children}
          </SnackbarProvider>
        </ThemeProvider>
      </Provider>
    );
  }
  return (
    <Provider store={store}>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {children}
      </SnackbarProvider>
    </Provider>
  );
};

export default SFProvider;
